import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '@core/const';

@Injectable({ providedIn: 'root' })
export class StrapiBaseUrlService {
  constructor(@Inject(PLATFORM_ID) private platformId: string) {}

  get baseUrl(): string | null {
    return (
      (isPlatformServer(this.platformId) ? environment.strapiBaseUrlSsr : environment.strapiBaseUrlCsr) ||
      environment.strapiBaseUrlCsr
    );
  }

  get baseApiUrl(): string | null {
    return this.baseUrl ? `${this.baseUrl}/api` : null;
  }
}
